import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import reportWebVitals from './reportWebVitals';

import App from './App';
import './index.scss';

const antdTheme = {
  token: {
    colorPrimary: '#FF0000',
    colorSecondary: '#FF0000',
    borderRadius: 8,
    fontFamily: '"Poppins", sans-serif',
  },
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.Fragment>
    <ConfigProvider theme={antdTheme}>
    <App />
    </ConfigProvider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
